import { Reveal } from '../lib/site';

/* Shared layout for the ported legal pages. Text is carried over from the
   pre-rebuild site; punctuation only was normalized to house style. */
export default function Legal({ title, effective, sections }) {
  return (
    <main>
      <section style={{ padding: 'clamp(130px, 15vw, 170px) 0 clamp(70px, 9vw, 110px)' }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          <Reveal>
            <p className="mono" style={{ fontSize: 12.5, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--fairway)', fontWeight: 500, marginBottom: 20 }}>
              Legal
            </p>
            <h1 className="h2" style={{ fontSize: 'clamp(2.1rem, 4.2vw, 3.1rem)' }}>{title}</h1>
            <p className="mono" style={{ fontSize: '0.85rem', color: 'var(--mut)', marginTop: 14 }}>
              Effective: {effective}
            </p>
          </Reveal>
          <div style={{ marginTop: 40, display: 'grid', gap: 30 }}>
            {sections.map((s, i) => (
              <Reveal key={i}>
                {s.h && (
                  <h2 className="h3" style={{ fontSize: '1.18rem', marginBottom: 12 }}>{s.h}</h2>
                )}
                {(s.ps || []).map((p, j) => (
                  <p key={j} style={{ color: 'var(--mut)', fontSize: '0.98rem', lineHeight: 1.75, marginBottom: 12 }}>{p}</p>
                ))}
                {s.lis && (
                  <ul style={{ margin: '4px 0 0', paddingLeft: 22, display: 'grid', gap: 8 }}>
                    {s.lis.map((li, j) => (
                      <li key={j} style={{ color: 'var(--mut)', fontSize: '0.98rem', lineHeight: 1.7 }}>{li}</li>
                    ))}
                  </ul>
                )}
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
